import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewWhatsDoneModule"
const debug = false

export class ViewWhatsDoneModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_WHATS_DONE, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "What's done"
        this.description             = ""
        this.svgIcon                 = "isvg-view-whats-done"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Views"
        this.settingsUrl             = "settings/view-whats-done"
        this.parentSection              = SettingsParentSection.VIEWS
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}